/*
 * @Author: 月魂
 * @Date: 2022-09-19 10:18:40
 * @LastEditTime: 2022-09-22 13:27:11
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \food-show\src\i18n\langs\zh.js
 */
export default {}
